export const LIST_BOOKID = 'LIST_BOOKID';
export const CREATE_BOOKID = 'CREATE_BOOKID';
export const SHOW_BOOKID = 'SHOW_BOOKID';
export const UPDATE_BOOKID = 'UPDATE_BOOKID';
export const DELETE_BOOKID = 'DELETE_BOOKID';
export const ADD_DELETE = 'ADD_DELETE';
export const CHECK_ALL = 'CHECK_ALL';
export const LIST_CATEGORY = 'LIST_CATEGORY';
export const CHECK_INPUT_ITEM = 'CHECK_INPUT_ITEM';
export const DATA_REMOVE_BOOKID = 'DATA_REMOVE_BOOKID';
export const LIST_BOOKID_CATEGORY = 'LIST_BOOKID_CATEGORY';
export const BOOKID_UPDATE_RELATE = 'BOOKID_UPDATE_RELATE';
export const UPDATE_META_DATA = 'UPDATE_META_DATA';
export const LIST_CODE = 'LIST_CODE';
export const CREATE_CODE = 'CREATE_CODE';
export const DELETE_CODE = 'DELETE_CODE';
export const BOOK_ID_MEMBER = 'BOOK_ID_MEMBER';
export const REMOVE_MEMBER = 'REMOVE_MEMBER';
export const GET_INFO_EXPORT = 'GET_INFO_EXPORT';   